module.exports = __webpack_public_path__ + "static/media/8-3.b68be914.svg";